import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import withKeyLayer from 'react-key-layers';

import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../../common/Dialog';
import style from '../../../../styles/presentational/ClassRoom/Inbox/inboxCreateGroupStyle';
import AutocompleteUser from '../common/AutocompleteUser';
import onlyWhenTrue from '../ConversationModal/onlyWhenTrue';
import { flow } from '../utils';

import * as TEXT from '../../../../constants/texts';

const initialState = {
  users: [],
  groupName: '',
  showGroupName: false,
  activeNext: false,
};

class CreateInboxGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.handleChangeGroupName = this.handleChangeGroupName.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleCreateGroup = this.handleCreateGroup.bind(this);
    this.getDisplayState = this.getDisplayState.bind(this);
  }

  getDisplayState() {
    const { users, groupName } = this.state;

    const showGroupName = users.length > 1;

    const singleUser = users.length === 1;
    const multipleUsersAndValidGroupName =
      groupName.length > 2 && users.length > 1;
    const activeNext = singleUser || multipleUsersAndValidGroupName;

    return { showGroupName, activeNext };
  }

  handleChangeUser(users) {
    this.setState({ users }, () => {
      this.setState(this.getDisplayState());
    });
  }

  handleChangeGroupName(e) {
    const groupName = e.target.value;

    this.setState({ groupName }, () => {
      this.setState(this.getDisplayState());
    });
  }

  handleRequestClose() {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  }

  handleCreateGroup() {
    const { showGroupName, groupName, users } = this.state;
    const { createGroup, handleCreateGroup } = this.props;

    if ((showGroupName && groupName && users.length) || users.length === 1) {
      const result = createGroup({ title: groupName || '-', users });

      if (!result) {
        return;
      }
      result.then((group) => {
        if (group) {
          handleCreateGroup(group.objectId);
        }

        this.handleRequestClose();
        this.setState(initialState);
      });
    }
  }

  render() {
    const { isCreatingGroup, open } = this.props;
    const { activeNext, showGroupName } = this.state;

    return (
      <Dialog
        id="create-conversation-dialog"
        open={open}
        onClose={this.handleRequestClose}
        maxWidth="md"
        style={{ zIndex: 1600 }}
      >
        <DialogTitle
          onClose={this.handleRequestClose}
          id="create-conversation-dialog-dialogtitle"
          data-testid="create-conversation-dialog-title"
        >
          Create a conversation
        </DialogTitle>
        <DialogContent>
          <div style={style.wrapper}>
            <div style={style.to}>To:</div>
            <div style={style.autocompleteWrapper}>
              <AutocompleteUser onChange={this.handleChangeUser} />
            </div>
            {showGroupName ? (
              <TextField
                hintText={TEXT.INPUT_TEXT_INBOX_GROUP}
                floatingLabelText="Group Name"
                onChange={this.handleChangeGroupName}
                style={style.groupNameField}
              />
            ) : null}
          </div>
        </DialogContent>
        <DialogActions
          primary={{
            className: 'create-conversation-group',
            label: 'Next',
            onClick: this.handleCreateGroup,
            loading: isCreatingGroup,
            disabled: !activeNext,
            htmlAttributes: {
              'aria-label': 'Next',
              'data-testid': 'create-coversation-next-button',
            },
          }}
          secondary={{
            label: 'Cancel',
            onClick: this.handleRequestClose,
          }}
        />
      </Dialog>
    );
  }
}

CreateInboxGroup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  createGroup: PropTypes.func.isRequired,
  isCreatingGroup: PropTypes.bool.isRequired,
  handleCreateGroup: PropTypes.func.isRequired,
};

const wrap = flow(withKeyLayer, onlyWhenTrue(['open']));

export default wrap(CreateInboxGroup);
